import React, {PureComponent} from 'react';
import propTypes from 'prop-types';
import {default as Checkbox} from '@sinclair-digital/sbg-storyline-components/src/components/forms/Checkbox';
import classes from './BulkEditTableRow.scss';
import {
    FETCH_STATUS,
} from '../constants';

export default class BulkEditTableRow extends PureComponent {
    static propTypes = {
        onItemSelect: propTypes.func,
        resultsIndex: propTypes.number,
        result: propTypes.shape({
            uuid: propTypes.string,
            status: propTypes.string,
            fetchStatus: propTypes.string,
            type: propTypes.string,
            byLine: propTypes.string,
            title: propTypes.string,
            selected: propTypes.bool,
            headline: propTypes.string,
        }),
    };

    handleSelect = () => {
        const {resultsIndex, onItemSelect} = this.props;

        onItemSelect(resultsIndex);
    };

    render() {
        const {
            result: {
                uuid,
                status,
                fetchStatus,
                type,
                byLine,
                headline,
                selected,
            },
        } = this.props;

        return (
            <tr
                key={uuid}
                className={
                    fetchStatus === FETCH_STATUS.PENDING
                        ? classes.pending
                        : ''
                }
            >
                <td>
                    <a href={`/#story/${uuid}`} target="_blank" rel="noopener noreferrer">
                        {uuid}
                    </a>
                </td>
                <td>{status}</td>
                <td>{type}</td>
                <td>{byLine}</td>
                <td>{headline}</td>
                <td>
                    <Checkbox checked={selected} onChange={this.handleSelect} />
                </td>
            </tr>
        );
    }
}
